// extracted by mini-css-extract-plugin
export default {"article":"TimeLine_article__q+t2r"};